/* eslint-disable no-unused-expressions */
/*  react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FixedContainer from "../../../../../components/Container";
import { Box, Typography, Button, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { GetFetch, PostFetch } from "../../../../../services/apiBase";

const Registro = (props) => {

  const location = useLocation();
  const navigate = useNavigate()

  const [registerLoading, setRegisterLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cprId, setCprId] = useState(null);
  const [personneId, setPersonneId] = useState(null);
  const [cprData, setCprData] = useState(null);

  const [viewRawData, setViewRawData] = useState(null);
  const [brpId, setBrpId] = useState('');

  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const [cpr, setCpr] = useState(null);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!location.state) {
      return navigate('/cprf/acompanhamento_B3')
    } else {
      setCprId(location.state.cprId)
      setPersonneId(location.state.personneId)
      setCpr(location.state.cpr);
    }
  }, [location]);

  const getCpr = useCallback(async () => {
    if (!cprId) return;
    setLoading(true)

    try {

      const response = await GetFetch(`/financial/b3/detail/${cprId}`);
      // const response = await axios.get(`http://localhost:4600/financial/b3/detail/${cprId}`);
      setCprData(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [cprId])

  const handleB3Register = useCallback(async (cprId, personneId, type, b3Id) => {
    setRegisterLoading(true);

    try {
      const body = {
        cprId,
        personneId,
        username: user.username,
      };
      if (type != 'B3') {
        body['b3Id'] = b3Id,
        body['type'] = type
      }

      await PostFetch("/financial/b3/register", body);
      enqueueSnackbar('CPR registrada com sucesso!', { variant: 'success' });

      return navigate('/cprf/acompanhamento_B3')

    } catch (err) {
      console.log({ err });
      enqueueSnackbar('Erro ao registrar a CPR', { variant: 'error' });
      
    } finally {
      handleOpenDialog(false)
      setRegisterLoading(false);
    }

  }, [])

  const handleOpenDialog = (value) => {
    setOpenDialog(value);
  };

  const loadingComponent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          paddingTop: 2
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os dados da CPRF
        </Typography>
      </Box>
    )
  }

  const registerButtonContainer = () => {
    return (
      <Box sx={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        marginTop: 2,
      }}>
        <Button variant="contained" sx={{ marginRight: 1 }} onClick={() => navigate('/cprf/acompanhamento_B3')}>Voltar</Button>
        <Button
          disabled={ type != 'B3' &&  brpId == '' }
          variant="contained"
          color="success"
          onClick={() => handleOpenDialog(true)}
          sx={{
            marginRight: 1
          }}>
            Registrar
        </Button>
      </Box>
    )
  }

  const formComponent = () => {
    return (
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Selecione a forma de cadastro</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={type}
            label="Selecione a forma de cadastro"
            onChange={handleChange}
          >
            {(cpr.investor_custody == 'FINPEC' && cpr.register_mode == 'B3') && <MenuItem value={"B3"}>Diretamente da B3</MenuItem>}
            <MenuItem value={"BRP"}>Via BRP</MenuItem>
            <MenuItem value={"NOVA_FUTURA"}>Via Nova Futura</MenuItem>
            <MenuItem value={"OUTROS"}>Outro</MenuItem>
          </Select>
        </FormControl>
      </Box>
    )
  }

  const checkBoxContainer = () => {
    return (
      <FormGroup sx={{margin: "20px 0"}}>
        <FormControlLabel control={
          <Checkbox
            checked={viewRawData}
            onChange={e => {
              setViewRawData(!viewRawData)
            }}
          />
        } label="Visualizar dado bruto" />
      </FormGroup>
    )
  }

  const inputContainer = () => {
    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: '100%',
          margin: "20px 0"
        }}
      >
        <TextField fullWidth label="ID do cadastro" id="fullWidth" onChange={e => setBrpId(e.target.value)} />
      </Box>
    )
  }

  useEffect(() => {
    getCpr();
  }, [getCpr])

  return (

    <FixedContainer>
      <Box sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#F9FBFD",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        boxShadow: 3,
        borderRadius: "10px",
        padding: 2,
      }}>
        {!loading ?
          cprData ? 
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}>
                CPRF's/Registro
              </Typography>

              <Box sx={{
                width: "100%",
                height: "100%",
                backgroundColor: "#F9FBFD",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                boxShadow: 2,
                borderRadius: "10px",
                padding: 2,
              }}>
                {formComponent()}
                {type != 'B3' && inputContainer()}
                {checkBoxContainer()}

                {viewRawData &&
                  <pre>
                    {JSON.stringify(cprData, null, 2)}
                  </pre>
                }

              </Box>
              {registerButtonContainer()}
            </Box>
          : errorMessage()
        : loadingComponent()
        }

      </Box>
      <Dialog
        open={openDialog}
        fullWidth={true}
        maxWidth={"sm"}
        onClose={() => handleOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Atenção"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{
            registerLoading ? loadingComponent() : `Essa ação não pode ser desfeita, tenha certeza de que todos os dados estão corretos.`
          }
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={registerLoading} onClick={() => handleOpenDialog(false)}>Fechar</Button>
          <Button disabled={registerLoading} onClick={() => handleB3Register(cprId, personneId, type, brpId)} autoFocus>
            Registrar
          </Button>
        </DialogActions>
      </Dialog>
    </FixedContainer>
  );
};

export default Registro;
